module.exports = __webpack_public_path__ + "static/mile-high-boys-club2.7f361d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mile-high-boys-club2.png
// module id = 753
// module chunks = 165866024739752 173894859265406